import axios from "axios";
import qs from "qs";
import router from "../router";

// 根据环境变量判断是否使用代理
// 开发环境使用相对路径走代理，生产环境直接请求后端地址
const baseURL = process.env.NODE_ENV === 'development' ? '' : "https://official.allijia.com/back";

export default {
	install(Vue, opts = {}) {
		/**
		 * 全局配置文件
		 */
		let $http = axios.create({
			baseURL,
			timeout: 60 * 1000,
			headers: {
				// TODO 后端服务器采用的是该编码格式 后期统一转换成json格式
				"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
				// "jzToken": userInfo ? userInfo.token : ''
			},
		});

		let $httpblob = axios.create({
			baseURL,
			timeout: 180 * 1000,
			responseType: "blob",
			headers: {
				"Content-Type": "application/json",
			},
		});

		/**
		 * 全局拦截请求
		 *
		 */
		$http.interceptors.request.use(
			function(config) {
				let userInfo = JSON.parse(window.localStorage.getItem("userInfo") || "{}");
				config.headers.jzToken = userInfo.token || "";
				// 序列化请求参数
				// if (config.method === 'post' || config.method === 'get') config.data = qs.stringify(config.data)
				return config;
			},
			function(error) {
				return Promise.reject(error);
			}
		);

		/**
		 * 全局拦截响应
		 */
		$http.interceptors.response.use(
			function(res) {
				let userInfo = JSON.parse(window.localStorage.getItem("userInfo") || "{}");
				let errcode = res.data.code;
				if (errcode == "00000") {
					//成功
					return res; //传数据
				} else if (errcode == "400" && res.data.message == "用户登录失效") {
					//未登录
					Vue.prototype.$Notice.warning({
						type: "warning",
						title: res.data.desc,
					});
					router.replace({
						path: "/login",
					});
				}
				return res;
			},
			function(error) {
				return Promise.reject(error);
			}
		);

		async function post(url, param = {}, callback) {
			const res = await $http.post(url, qs.stringify(param));
			if (res.status === 200 && parseInt(res.data.code) != 200) {
				Vue.prototype.$Notice.warning({
					title: res.data.message,
				});
				if (Object.prototype.toString.call(callback) === "[object Function]") return callback(res);
				return Promise.reject("出错了");
			}
			return res.data.data;
		}
		async function get(url, param = {}, callback) {
			let formatParam = "";
			if (param) {
				for (let k in param) {
					// if (!param[k] && k!='skip') continue;
					formatParam += k + "=" + param[k] + "&";
				}
				formatParam = formatParam.substr(0, formatParam.length - 1);
				url = url + "?" + formatParam;
			}
			const res = await $http.get(url);
			if (res.status === 200 && parseInt(res.data.code) != 200) {
				Vue.prototype.$Notice.warning({
					title: res.data.message,
				});
				if (Object.prototype.toString.call(callback) === "[object Function]") return callback(res);
				return Promise.reject("出错了");
			}
			return res.data.data;
		}

		async function uploadFile(url, param = {}, callback) {
			const res = await $http.post(url, param);
			if (res.status === 200 && parseInt(res.data.code) != 200) {
				Vue.prototype.$Notice.warning({
					title: res.data.message,
				});
				if (Object.prototype.toString.call(callback) === "[object Function]") return callback(res);
				return Promise.reject("出错了");
			}
			return res.data.data;
		}

		async function put(url, param = {}, callback) {
			const res = await $http.put(url, param);
			return res;
		}
		//导出-二进制流
		async function blobpost(url, param = {}, callback) {
			const res = await $httpblob.get(url, param);
			return res;
		}

		Vue.prototype.$post = post;
		Vue.prototype.$get = get;
		Vue.prototype.$put = put;
		Vue.prototype.$blobpost = blobpost;
		Vue.prototype.$http = $http;
		Vue.prototype.$httpblob = $httpblob;
		Vue.prototype.$upload = uploadFile;
		window.$post = post;
		window.$get = get;
		window.$put = put;
		window.$blobpost = blobpost;
		window.$upload = uploadFile;
	},
};
